/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Chip,
  Grid,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

const SelectAddSerialForm = (props) => {
  const { serials: propSerials, onAdd, onDelete, readOnly } = props;
  const [newSerial, setNewSerial] = useState('');
  const [serials, setSerials] = useState(propSerials);
  useEffect(() => {
    setSerials(propSerials);
  }, [propSerials]);

  const onChangeGroupInput = (e) => {
    const {
      target: { value },
    } = e;
    setNewSerial(value);
  };

  const onAddGroupClick = () => {
    const check =
      serials && serials.filter(({ label }) => label === newSerial.trim());
    if (!check || !check.length) {
      onAdd(newSerial, 'serials-add');
      setNewSerial('');
    }
  };
  return (
    <Box>
      <Typography variant="subtitle2">시리얼 추가</Typography>
      <Grid container sx={{ alignItems: 'center' }} spacing={1}>
        {!readOnly && (
          <>
            <Grid item xs={12} lg={6} xl={7}>
              <TextField
                name="group-text-input"
                placeholder="시리얼을 입력하세요."
                value={newSerial || ''}
                onChange={onChangeGroupInput}
                margin="dense"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} lg={6} xl={5}>
              <Button
                color="secondary"
                variant="outlined"
                onClick={onAddGroupClick}
                disabled={newSerial.length === 0}
                startIcon={<AddIcon />}
              >
                시리얼 추가
              </Button>
            </Grid>
          </>
        )}
        <Grid item xs={12}>
          <Stack direction="row" flexWrap="wrap" gap={1}>
            {serials &&
              serials.map((item) => (
                <Chip
                  label={item}
                  name={`${item}`}
                  key={`${item}`}
                  color="secondary"
                  variant="outlined"
                  onDelete={() => onDelete(item, 'serials-delete')}
                />
              ))}
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SelectAddSerialForm;
